module.exports = __webpack_public_path__ + "img/t2-email.4a8a9566.png";